import { formatRating, type RatingSummary } from "@/modules/reviews/surfaces";

/**
 * Public-profile rating roll-up display (H5). Pulls the formatted average from
 * Reviews, which is the single source of display precision. ConsumerBookings
 * renders its own stars, so this file stays presentational.
 * docs/ux/screens/BusinessPublicProfileScreen.md / PractitionerPublicProfileScreen.md
 */

/** Five glyphs, filled to the nearest whole star. Decorative, the number is the truth. */
function Stars({ value }: { value: number }) {
  const rounded = Math.round(value);
  return (
    <span className="text-base leading-none" aria-hidden="true">
      {[1, 2, 3, 4, 5].map((n) => (
        <span key={n} className={n <= rounded ? "text-accent" : "text-line"}>
          ★
        </span>
      ))}
    </span>
  );
}

export function RatingBadge({ summary }: { summary: RatingSummary }) {
  if (summary.count === 0 || summary.average === null) {
    return <p className="text-sm text-muted">No reviews yet</p>;
  }
  const label = summary.count === 1 ? "1 review" : `${summary.count} reviews`;
  return (
    <div className="flex items-center gap-2">
      <Stars value={summary.average} />
      <span className="text-sm font-semibold text-ink">
        {formatRating(summary.average)}
      </span>
      <span className="text-sm text-muted">· {label}</span>
    </div>
  );
}
